import EventTarget from '@ungap/event-target';

export class EventEmitter {
	public eventEmitter = new EventTarget();
}
